import styled, { keyframes } from "styled-components";

export const waveAnimation = keyframes`
  0% {
    opacity: 0;
    transform: translate3d(0, 50px, 0) scale3d(0.9, 0.9, 1);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale3d(1, 1, 1);
  }
`;

export const WavyCardContainer = styled.div`
    opacity:0;
    display:grid;
    grid-template-columns:1fr;
    justify-items:center;
    text-align:center;
    row-gap:3rem;
    max-width:320px;
    &.visible {
      opacity: 1;
      transform: translate3d(0, 0, 0) scale3d(1, 1, 1);
      animation: ${waveAnimation} 1s ease-out forwards;
  }
`;

export const WavyCardTitle = styled.h4`
    margin:0;

`;

export const WavyCardSubtitle = styled.p`

`;
